
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Skills from './components/Skills/Skills';
import Service from './components/Service/Service';
import Resume from './components/Resume/Resume';
import MyWork from './components/Myworks/MyWork';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ErrorBoundary from './components/Skills/ErrorBoundary';
function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <ErrorBoundary>
        <Skills />
      </ErrorBoundary>
      {/* <Service/> */}
      <Resume />
      <MyWork />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
